// import {
//   Tabs,
//   TabsContent,
//   TabsList,
//   TabsTrigger,
// } from "../../components/ui/tabs";
// import CommissionedTab from "./CommissionedTab";
// import PackTab from "./PackTab";
// import ShipTab from "./ShipTab";
// function Tab() {
//   return (
//     <div className="my-[30px]">
//       <Tabs defaultValue="commissioned" className="w-full overflow-hidden">
//         <TabsList>
//           <TabsTrigger value="commissioned">Items Commissioned</TabsTrigger>
//           <TabsTrigger value="packed">Items Packed</TabsTrigger>
//           <TabsTrigger value="shipped">Items Shipped</TabsTrigger>
//         </TabsList>
//         <TabsContent value="commissioned">
//           <CommissionedTab />
//         </TabsContent>
//         <TabsContent value="packed">
//           <PackTab />
//         </TabsContent>
//         <TabsContent value="shipped">
//           <ShipTab />
//         </TabsContent>
//       </Tabs>
//     </div>
//   );
// }

// export default Tab;



import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/tabs";
import CommissionedTab from "./CommissionedTab";
import PackTab from "./PackTab";
import ShipTab from "./ShipTab";

function Tab({ clientEmail, clientId  }) {
  return (
    <Tabs defaultValue="commissioned" className="w-full mt-6">
      <TabsList className="grid w-full grid-cols-3">
        <TabsTrigger value="commissioned">Commissioned</TabsTrigger>
        <TabsTrigger value="packed">Packed</TabsTrigger>
        <TabsTrigger value="shipped">Shipped</TabsTrigger>
      </TabsList>

      <TabsContent value="commissioned">
        <CommissionedTab clientEmail={clientEmail} clientId={clientId} />
      </TabsContent>

      <TabsContent value="packed">
        <PackTab clientEmail={clientEmail} clientId={clientId} />
      </TabsContent>

      <TabsContent value="shipped">
        <ShipTab clientEmail={clientEmail} clientId={clientId} />
      </TabsContent>
    </Tabs>
  );
}

export default Tab;